/* eslint-disable react/jsx-props-no-spreading */

import React from 'react'
import { string, func } from 'prop-types'
import { Route, useLocation } from 'react-router-dom'
import useDataLayer from '@hooks/useDataLayer'

export default function PageView({ component: Component, path }) {
  const locationHook = useLocation()
  const { events: eventsDataLayer } = useDataLayer()

  eventsDataLayer.virtualPageView(locationHook.pathname)

  return (
    <Route
      exact
      path={path}
      render={props => {
        return <Component {...props} />
      }}
    />
  )
}

PageView.propTypes = {
  component: func.isRequired,
  path: string.isRequired,
}
